import state from '@/vuex/juntada/state.js'
import getters from '@/vuex/juntada/getters.js'
import mutations from '@/vuex/juntada/mutations.js'
import actions from '@/vuex/juntada/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
